export default __webpack_public_path__ + "static/media/bg-300.14a4780d.png";